import {ApiRequest} from './request'

export default function(app) {

    const $membershipTag = $('.membership-tag')
    const $body = $('body')

    if($membershipTag.length === 0) return

    $body.on('click', '.membership-tag .save-action', async function(event) {

        event.preventDefault()

        const $button = $(this)

        if($button.hasClass('saving')) return

        $button.addClass('saving')

        const $save = $button.find('.text-save')
        const $saved = $button.find('.text-saved')

        // Get the data
        const promise = $.ajax({
            url: $button.data('url'),
            dataType: 'json',
            data: $button.parents('form').serialize(),
            type: 'POST'
        })

        promise.done(function(){
            $save.hide()
            $saved.show()
            setTimeout(function(){
                $saved.hide()
                $save.show()
            }, 3000)
        })

        promise.always(function(){
            $button.removeClass('saving')
        })

    })

}
